import React from 'react';

import { Divider, Typography } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

const { Paragraph, Title } = Typography;

export interface WorkJourneyFormSectionProps {
  titleId: string;
  titleMessageId: string;
  descriptionMessageId?: string;
  children: React.ReactNode;
  showDivider?: boolean;
}

const WorkJourneyFormSection = ({
  titleId,
  titleMessageId,
  descriptionMessageId,
  children,
  showDivider = true,
}: WorkJourneyFormSectionProps) => (
  <>
    <section className={styles.formSection} aria-labelledby={titleId}>
      <Title id={titleId} level={5} className={styles.formSectionTitle}>
        <IntlMessages id={titleMessageId} />
      </Title>
      {descriptionMessageId && (
        <Paragraph className={styles.descriptionText}>
          <IntlMessages id={descriptionMessageId} />
        </Paragraph>
      )}
      {children}
    </section>
    {showDivider && <Divider className={styles.divider} />}
  </>
);

export default WorkJourneyFormSection;
